<template>

 <scroll-page :pull-reload="true">
   
   <page-padding v-if="computeUserAccess">
      <button-action :to="'/documents/'+download_id+'/add_item/'" title="language.add_documents_item" ></button-action>
   </page-padding>
   
    <list-documents :download_id="download_id"/>
</scroll-page>

</template>

<script>

import { mapState } from 'vuex';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import ListDocuments from '../components/documents/ListDocuments';
import ScrollPage from '../components/ScrollPage.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';

export default {
  name: 'group-documents-page',
  data:function(){
    return{
      id:this.$route.params.id,
      download_id:undefined,
    }
  },
  computed:{
     ...mapState([
       'groups','appSettings','group'
       ]),
       computeUserAccess(){
        if(!this.group.authorized){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  components: {
    ButtonAction,
    PagePadding,
    ListDocuments,
    ScrollPage,
  },
  methods:{ 
   
  },
  created(){
    
    //this.group = this.groups.find(group => group.id === this.id);
    this.download_id = this.group.download_id;
   
  }
}

    
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
